import styles from './Bootstrap.module.css';

/**
 * @deprecated Don't use any Bootstrap styling.
 *
 * Use a CSS Module instead with a custom class (YourComponent.module.css), or a Blueprint.js component.
 */
export const BootstrapStyles = styles;
